import KonfigurasiAngket from "../../../../../components/categories/siakad/laporan_adab/konfigurasi-angket/HomeTeacher"
export default function Home() {
  
  return (
    <KonfigurasiAngket />
  );
}
